import { ApiServiceError } from '../hooks/api/useApiService';

export const isApiServiceErrorResponse = <ResponseType>(
  error: unknown
): error is ApiServiceError<ResponseType> =>
  !!error && typeof error === 'object' && 'error' in error && 'message' in error;
